
import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class CoachAppSvg extends Vue{
	@Prop({ default: false, type: Boolean }) active: boolean;
	get Opacity(): string{
		if(this.active) return '1';
		return '0.5';
	}
}
